'use client';

import Link from 'next/link';
import classes from './SignatureStats.module.scss';
import { IconArrowRight, IconSparkles, IconTrendingUp } from '@tabler/icons-react';

type StatCard = {
  label: string;
  value: string;
  helper?: string;
};

type SignatureStatsProps = {
  title: string;
  subtitle?: string;
  cards: StatCard[];
  note?: string;
  ctaLabel?: string;
  ctaHref?: string;
  badge?: string;
};

export const SignatureStats = ({ data }: { data: SignatureStatsProps }) => {
  const { title, subtitle, cards = [], note, ctaLabel, ctaHref, badge } = data;

  return (
    <section className={classes.section} aria-labelledby="stats-title">
      <div className={classes.container}>
        <div className={classes.header}>
          {badge && (
            <div className={classes.badgeWrapper}>
              <IconSparkles size={18} className={classes.badgeIcon} />
              <span className={classes.badge}>{badge}</span>
            </div>
          )}
          <h2 id="stats-title" className={classes.title}>
            {title}
          </h2>
          {subtitle && <p className={classes.subtitle}>{subtitle}</p>}
        </div>

        <div className={classes.cards}>
          {cards.map((card, index) => (
            <article key={`${card.label}-${index}`} className={classes.card}>
              <div className={classes.cardContent}>
                <div className={classes.valueWrapper}>
                  <span className={classes.value}>{card.value}</span>
                  {card.value.includes('+') || card.value.includes('%') ? (
                    <IconTrendingUp size={24} className={classes.trendIcon} />
                  ) : null}
                </div>
                <div className={classes.labelWrapper}>
                  <span className={classes.label}>{card.label}</span>
                  {card.helper && <span className={classes.helper}>{card.helper}</span>}
                </div>
              </div>
            </article>
          ))}
        </div>

        {(note || (ctaLabel && ctaHref)) && (
          <div className={classes.footer}>
            {note && <p className={classes.note}>{note}</p>}
            {ctaLabel && ctaHref && (
              <Link href={ctaHref} className={classes.cta}>
                {ctaLabel}
                <IconArrowRight size={18} className={classes.ctaIcon} />
              </Link>
            )}
          </div>
        )}
      </div>
    </section>
  );
};
